import { useDispatch } from "react-redux"
import { useLocation } from "react-router-dom"
import styled from "styled-components"
import { useScrollLock } from "../../../hooks/useScrollLock"
import { useSelector } from "react-redux"
import { useEffect, useState } from "react"
import { showModal } from "../../../features/modal/modalSlice"
import AddLoadMapWideMapSide from "../../load/addLoadMapWide/AddLoadMapWideMapSide"
import AddLoadMapWideRouteSide from "../../load/addLoadMapWide/AddLoadMapWideRouteSide"
const Container = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: ${({theme}) => theme.mainBgColor};
    z-index: 26;

    .wrapper{
      width: 100%;
      display: flex;


      .map-side{
        width: calc(100% - 200px);

      }
    }
`

const AddLoadMapWideModal = () => {

  const dispatch = useDispatch()
  const location = useLocation()

  const {modalLocation } = useSelector(state => state.modal)
  const { lockScroll, unlockScroll } = useScrollLock();
  const { route } = useSelector((state) => state.addLoad);

  //! bu modal açıldığnda ekran ı lock lamak için
  useEffect(() => {
      lockScroll()

      return () => {
          unlockScroll()
      }
  }, [lockScroll, unlockScroll])

  //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
  useEffect(() => {
      if (location.pathname !== modalLocation) {
          dispatch(showModal(null))
      }
  }, [dispatch, location.pathname, modalLocation])




  return (
    <Container>
        <div className="wrapper">
        <AddLoadMapWideRouteSide route={route}/>
        <AddLoadMapWideMapSide route={route.map(item => item.locationData)}/>
        </div>
    </Container>
  )
}

export default AddLoadMapWideModal